import { AccountAppDTO } from "../apps/AccountApp";
import { FacilityDTO } from "../facilities/Facility";
import { RoleDTO } from "../roles/Role";

export interface AccountRelatedDTO {
  apps: AccountAppDTO[];
  catalog: any;
  facilities: FacilityDTO[];
  id: number;
  name: string;
  reports: any[];
  accountUserGroups: any[];
  roles: RoleDTO[];
  stripeCustomers: any[];
  features: any[];
}

export interface AccountDTO {
  address1: string;
  address2: string;
  business_category: string;
  catalog: any;
  city: string;
  config: any;
  disabled: boolean;
  id: number;
  name: string;
  phone: string;
  postal_code: string;
  state_province: string;
  stripe_customer_id: string;
  tos_treshold_seconds: number;
  first_name: string;
  last_name: string;
  email: string;
  users?: any;
  service_level?: string;
  stripeCustomers: any[];
  features: any[];
}

export class Account {
  groups?: any[];
  facilities?: FacilityDTO[];
  constructor(
    private _accountDTO: AccountDTO,
    private _accountRelatedDTO?: AccountRelatedDTO,
  ) {}

  get apps() {
    return this._accountRelatedDTO?.apps;
  }

  get address1() {
    return this._accountDTO.address1;
  }

  get address2() {
    return this._accountDTO.address2;
  }

  get business_category() {
    return this._accountDTO.business_category;
  }

  get catalog() {
    return this._accountDTO.catalog;
  }

  get city() {
    return this._accountDTO.city;
  }

  get config() {
    return this._accountDTO.config;
  }

  get disabled() {
    return this._accountDTO.disabled;
  }

  get selectedFacilities() {
    return this._accountRelatedDTO?.facilities!;
  }

  set selectedFacilities(value: FacilityDTO[]) {
    this._accountRelatedDTO!.facilities = value;
  }

  get id() {
    return this._accountDTO.id;
  }

  get name() {
    return this._accountDTO.name;
  }

  get phone() {
    return this._accountDTO.phone;
  }

  get postalCode() {
    return this._accountDTO.postal_code;
  }

  get reports() {
    return this._accountRelatedDTO?.reports;
  }

  get state() {
    return this._accountDTO.state_province;
  }

  get stripeCustomerID() {
    return this._accountDTO.stripe_customer_id;
  }

  get tosTresholdSeconds() {
    return this._accountDTO.tos_treshold_seconds;
  }

  get accountDTO() {
    return this._accountDTO;
  }

  get accountRelatedDTO() {
    return this._accountRelatedDTO;
  }
}
